import Vue from "vue";
import { NavigationGuardNext, Route } from "vue-router";
import { tryUnload } from "./unloadModal";

/**
 * Service need for showing builtin unload modal or customizable "Modal"
 * when form has unsaved data and user trying leave page by: [closing tab, reloading page, moving to another $route]
 */
export class UnloadService {

    private vmGuardUnregister: Function | null = null;

    constructor(private vm: Vue, watchProp: string, private resetConfirmText: string) {

        // watch resetable
        vm.$watch(watchProp, (resetable: boolean) => this.watchHandler(resetable));
    }

    unsubscribe() {
        this.unsubscribeToUndload();

        //UNREGISTER guard
        if (this.vmGuardUnregister) {
            this.vmGuardUnregister();
        }
    }

    async trigger() {
        const confirmed = await tryUnload(this.resetConfirmText);

        if(confirmed) {
            return true;
        }

        return false;
    }

    private watchHandler(resetable: boolean) {
        // before unload
        if (resetable) {

            this.vmGuardUnregister = this.vm?.$router.beforeEach((to, _, next) => this.vmGuard(to, next)) || null;
            this.subscribeToUndload();
        }
        else {
            this.unsubscribe();
        }
    }

    private async vmGuard(to: Route, next: NavigationGuardNext) {
        if(this.vm?.$route.name !== to.name) {
            const confirmed = await tryUnload(this.resetConfirmText);

            if (confirmed) {
                next();
            }
        }
        else {
            next();
        }
    }

    private unloadHandler(event: BeforeUnloadEvent) {
        // Отмените событие, как указано в стандарте.
        event.preventDefault();
        // Chrome требует установки возвратного значения.
        event.returnValue = '';
    }

    private subscribeToUndload() {
        window.addEventListener('beforeunload', this.unloadHandler);
    }

    private unsubscribeToUndload() {
        window.removeEventListener('beforeunload', this.unloadHandler);
    }
}